import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import { Box, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import useTranslate from '../../../../localization/helpers';
var AiSummaryDrawer = function (_a) {
    var open = _a.open, onClose = _a.onClose, document = _a.document;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    return (_jsxs(Drawer, { anchor: isXs ? 'bottom' : 'right', open: open, onClose: onClose, slotProps: {
            paper: {
                sx: {
                    width: isXs ? '100%' : '400px',
                    padding: 2
                }
            }
        }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '4px', children: [_jsx(Typography, { variant: 'h6', children: translate('knowledge.aiSummary') }), _jsx(Typography, { variant: 'body2', color: theme.palette.text.secondary, children: document === null || document === void 0 ? void 0 : document.title })] }), _jsx(IconButton, { onClick: onClose, children: _jsx(CloseIcon, {}) })] }), _jsx(Box, { my: 2, children: (document === null || document === void 0 ? void 0 : document.aiSummary) ? (_jsx(Typography, { variant: 'body1', children: document.aiSummary })) : (_jsx(Typography, { variant: 'body1', children: translate('knowledge.noAiSummary') })) })] }));
};
export default AiSummaryDrawer;
